import React, { useContext, useEffect, useState } from 'react';
import { UseFormMethods } from 'react-hook-form';
import LoadingSpinner from 'src/components/common/LoadingSpinner';
import { FixedSizeList as List } from 'react-window';
import { LandSystem } from 'src/models/LandSystem';
import ReportDataTree from 'src/models/reports/ReportDataTree';
import ReportTownshipDto from 'src/models/reports/ReportTownshipDto';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';

interface IReportFilterLocationProps extends Partial<Pick<UseFormMethods, 'getValues' | 'setValue' | 'register'>> {
    // selectedHorizonIds: number[];
    townships: ReportTownshipDto[];
    landSystemId: LandSystem;
    selectAll: boolean;
    expandAll: boolean;
    loadingFields: boolean;
    selectedHorizons: ReportDataTree[];
    width: number;
    filteredList: ReportDataTree[];

    refreshTagValues: () => void;
    setLoadingFields: (loading: boolean) => void;
    setSelectedHorizons: (horizons: ReportDataTree[]) => void;
    setFilteredList: (list: ReportDataTree[]) => void;
    flattenItems: (nodes: ReportDataTree[], showChildren?: boolean) => ReportDataTree[];
}

const ReportFilterLocation = (props: IReportFilterLocationProps) => {
    const appContext = useContext<IAppContextState>(AppContext);
    const rowHeight = 20;
    
    const [parentTier, setParentTier] = useState<number>(undefined);

    useEffect(() => {
        if (props.townships?.length > 0) {
            props.setLoadingFields(false);
            props.refreshTagValues();
            let treeList: ReportDataTree[];
            let pTier: number;
            if (props.landSystemId === LandSystem.EastTexas) {
                // setExpandedFields([1]);
                let global = `${appContext.clientNumber},${appContext.projectNumber},${props.townships[0].fieldList[0].globalNumber}`;
                treeList = ReportDataTree.FromTracts(props.townships[0].fieldList[0].tractList, props.townships[0].fieldList[0].id, global);
                pTier = 3;
            } else {
                let isEastern = props.landSystemId === LandSystem.Eastern;
                treeList = ReportDataTree.FromTownships(props.townships, `${appContext.clientNumber},${appContext.projectNumber}`, isEastern);
                pTier = 1;
            }
            setParentTier(pTier);
            props.setFilteredList(props.flattenItems(treeList.filter(tl => tl.reportTier === pTier)));
        }
    }, [props.townships]);

    useEffect(() => {
        let newList = props.flattenItems(props.filteredList, true);
        for (let fl of newList) {
            fl.selected = props.selectAll;
            fl.expanded = fl.reportTier === parentTier && props.selectAll;
        }

        props.setFilteredList(props.flattenItems(newList.filter(fl => fl.reportTier === parentTier)));
    }, [props.selectAll]);

    useEffect(() => {
        let newList = props.flattenItems(props.filteredList, true);
        for (let fl of newList) {
            fl.expanded = props.expandAll;
        }

        props.setFilteredList(props.flattenItems(newList.filter(fl => fl.reportTier === parentTier)));
    }, [props.expandAll]);

    useEffect(() => {
        if (props.filteredList?.length > 0) {
            let filtered = props.filteredList.filter(fl => fl.selected);
            let hList = props.flattenItems(filtered, true).filter(fl => fl.reportTier === 4 && fl.selected);
            props.setSelectedHorizons(hList);
        }
    }, [props.filteredList]);

    const displayFlattenedList = () => {
        let flatRow = ({ index, style }: { index: number; style: React.CSSProperties }) => {
            const node = props.filteredList[index];
            let marginBuffer = '';

            switch (node.reportTier) {
                case 4:
                    marginBuffer = 'ml-6';
                    break;
                case 3:
                    marginBuffer = 'ml-4';
                    break;
                case 2:
                    marginBuffer = 'ml-2';
                    break;
                case 1:
                default:
                    break;
            }

            return (
                <div style={{ ...style, borderBottom: '1px solid grey' }}>
                    <div className={marginBuffer} style={{ display: 'flex' }}>
                        <div className="clickable" onClick={() => handleExpand(node.id, node.reportTier)}>
                            +
                        </div>
                        <div>
                            <input
                                name={node.reportGlobal}
                                id={node.reportGlobal}
                                type="checkbox"
                                onChange={() => handleSelect(node, true)}
                                defaultChecked={node.selected}
                                ref={props.register}
                                disabled={props.loadingFields}
                            />
                        </div>

                        {node.reportText}
                    </div>
                </div>
            );
        };

        return (
            <List
                height={400}
                itemCount={props.filteredList.length}
                itemSize={rowHeight}
                width={props.width}
            >
                {flatRow}
            </List>
        );
    };
    
    const handleExpand = (nodeId: number, nodeTier: number) => {
        let flatList = [...props.filteredList];
        let flatRow = flatList.find((fl) => fl.id === nodeId && fl.reportTier === nodeTier);
        flatRow.expanded = !flatRow.expanded;
        
        let newFlat = props.flattenItems(flatList.filter(fl => fl.reportTier === parentTier));
        props.setFilteredList(newFlat);
    };

    const handleSelect = (currentRow: ReportDataTree, isTop: boolean = false) => {
        let flatList = [...props.filteredList];

        if (currentRow.children.length > 0) {
            for (let c of currentRow.children) {
                flatList = handleSelect(c);
            }
        }

        currentRow.selected = !currentRow.selected;
        
        if (isTop) {
            currentRow.expanded = currentRow.selected;
            let newFlat = props.flattenItems(flatList.filter(fl => fl.reportTier === parentTier));
            props.setFilteredList(newFlat);
        }

        return flatList;
    };

    return (
        <div>

            {props.loadingFields && (
                <>
                    <LoadingSpinner />
                    <div>Loading Fields</div>
                </>
            )}
            {props.filteredList?.length > 0 && (
                displayFlattenedList()
            )}
        </div>
    );
};

export default ReportFilterLocation;



// WEBPACK FOOTER //
// ./src/components/project/sections/ReportComponents/ReportFilterLocation.tsx